import axios from "axios";
import { environment } from "../../environment";
import { createFormData } from "../helpers/helpers";

export const CommunitiesService = () => {
  const get = async () => {
    try {
      const path = environment.contentUrl + "communities";
      const res = await axios.get(path);
      if (res && res.data) return res.data;
      else {
        return [];
      }
    } catch (err) {
      throw err;
    }
  };

  const post = async (c: any) => {
    try {
      const path = environment.contentUrl + "communities";
      const formData = createFormData(c, new FormData());
      const res = await axios.post(path, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res && res.data) {
        return res.data;
      } else {
       
      }
    } catch (err) {
      throw err;
    }
  };

  const syncCommunities = async () => {
    try {
      const path = environment.authUrl + "sync/communities";
      const res = await axios.get(path);
      return res;
    } catch (err) {
      throw err;
    }
  };

  const update = async (c: any) => {
    try {
      const path = environment.contentUrl + `communities/${c._id}`;
      const formData = createFormData(c, new FormData());
      const res = await axios.put(path, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res && res.data) {
        return res.data;
      } else {
       //todo
      }
    } catch (err) {
      throw err;
    }
  };

  return {
    get,
    post,
    update,
    syncCommunities,
  };
};
